module.exports = __webpack_public_path__ + "static/media/patient.57290d29.jpg";